module.exports = __webpack_public_path__ + "media/recipes/107-dab737fb.png";